// extracted by mini-css-extract-plugin
export var borderLine = "style-mod--border-line--36d56";
export var reviewsContainer = "style-mod--reviews-container--23581";
export var tpLogo = "style-mod--tp-logo--a59a6";
export var trustpilotReviews = "style-mod--trustpilot-reviews--6a356";